var map = {
	"./arrow-down-icon.svg": "436c",
	"./basecamp-logo.png": "4b53",
	"./contact-icon.svg": "9668",
	"./emoji-wink copy.png": "8773",
	"./emoji-wink.png": "954c",
	"./feed-icon.svg": "d056",
	"./files-icon.svg": "e1e3",
	"./fus-icon.jpg": "6fff",
	"./hey-logo.svg": "038e",
	"./heyteam-logo.png": "9701",
	"./imbox-icon.svg": "4be6",
	"./logo.png": "cf05",
	"./nicola-icon.jpg": "dc0c",
	"./nicola.jpg": "97e0",
	"./ntu-icon.jpg": "f891",
	"./ntu-icon.png": "a84b",
	"./plus-icon.svg": "adf4",
	"./ps-icon.jpg": "e281",
	"./uon-icon.jpg": "4c06",
	"./uon-icon.png": "374e",
	"./yc-icon.jpg": "6b77",
	"./yc-icon.png": "c5bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";